import useSWR from 'swr';

import { generateApiPath, getCollection } from '#app/Handler/api';
import CarrierEntryPoints from '#app/entrypoints/carrier';
import { CarrierSelect } from '#app/typings/carrier';

type HookReturn = {
  carriers: CarrierSelect[];
};

const useCarriers = (): HookReturn => {
  const { data: carriers } = useSWR<CarrierSelect[]>(generateApiPath(CarrierEntryPoints.getSelect), getCollection, {
    revalidateOnFocus: false,
  });

  return {
    carriers: carriers ?? [],
  };
};

export default useCarriers;
